// components/Hero.js
import React, { useState, useEffect } from 'react';
import './Hero.css';

// Image imports are no longer needed as images are in public folder
// import imgLivingRoom2 from '../img/Living room (2).png';
// import imgLivingRoom6 from '../img/Living room (6).png';
// import imgBedroom1_3 from '../img/Bedroom 1 (3).png';
// import imgLivingRoom7 from '../img/Living room (7).png';

// The heroImages array now contains direct public URLs
const heroImages = [
  '/img/Living room (2).png', // Index 0
  '/img/Living room (6).png', // Index 1
  '/img/Bedroom 1 (3).png',  // Index 2
  '/img/Living room (7).png', // Index 3
];

function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % heroImages.length
      );
    }, 6000); // 6 seconds for a slower, more luxurious feel

    return () => clearInterval(interval);
  }, []);

  const handleScrollTo = (target) => {
    const element = document.querySelector(target);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="hero-bg-layers">
        {heroImages.map((src, index) => (
          <div
            key={src}
            className={`hero-bg-layer ${index === currentImageIndex ? 'active' : ''}`}
            style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${src}')` }}
          />
        ))}
      </div>
      <div className="hero-content">
        <h1 className="reveal">Luxury 360 Suite • WiFi, DSTV & Solar Backup</h1>
        <p className="reveal" style={{ transitionDelay: '0.2s' }}>Your perfect getaway in Abuja, Nigeria.</p>
        <button
          className="btn-primary reveal"
          onClick={() => handleScrollTo('#about')}
          style={{ transitionDelay: '0.4s' }}
        >
          Discover More
        </button>
      </div>
    </section>
  );
}

export default Hero;